export default function calculateWaterAvailable(values) {
  let irrigationTime = parseFloat(values.waterAccessHours); // hours of access
  let irrigationFrequency = parseFloat(values.waterAccessMonths); // days per month of access
  let irrigationRate = parseFloat(values.waterAccessFlowRate); // est. irrigation flow rate (L/s)

  return (irrigationTime * 3600 * irrigationRate * 30.4) / irrigationFrequency; // liters
}
